import { useContext, useMemo } from 'react';

import { StyledContainer } from './styles';
import { Logos } from '@/app/components/shared/Logos/Logos';
import ClientContext from '@/contexts/client.context';

const LogosBanner = ({ content }) => {
  const { centered, withBackground } = content;
  const { client } = useContext(ClientContext);

  const logos = useMemo(() => {
    const logoData = client.logo?.data || client.logos?.data;
    if (!logoData) return [];
    return Array.isArray(logoData) ? logoData.slice(0, 3) : [logoData];
  }, [client?.logo, client?.logos]);

  return (
    <StyledContainer>
      {client.clientKey ? (
        <Logos
          asSection
          centered={centered}
          client={client}
          customMaxHeight={24}
          customHeight={24}
          logos={logos}
          showSwordLogo={client.showSwordLogo}
          withBackground={withBackground}
        />
      ) : (
        <Logos
          asSection
          centered={centered}
          client={client}
          customMaxHeight={24}
          logos={[]}
          showSwordLogo
          withBackground={withBackground}
        />
      )}
    </StyledContainer>
  );
};

LogosBanner.defaultConfig = {
  rounded: false,
  colored: true,
  spaceBottom: false,
  spaceTop: false,
  marginBottom: false,
};

export default LogosBanner;
